import datacapture from '../../utils/datacapture/datacapture';
import { constants } from '../../utils/constants/constants';

/**
 * @method handleResponse
 * @summary this method takes the response and calls the appropriate
 * delegate methods to handle the status
 * @param  {Object} response
 */
export const handleResponse = ( response ) =>{
  const data = Array.isArray( response ) ? response[1]?.data : response?.data // response for mutation is an array and reponse will be in the first index
  let meta = null;
  if( data ){
    for ( const [key, value] of Object.entries( data ) ){
      if( value.meta ){
        meta = value.meta ;
        break;
      }
    }
  }

  if( meta?.ATG_STATUS ){
    handleATGResponseStatus( meta.ATG_STATUS )
  }

}

/**
 * @method triggerDatacaptureEventOnMutationResponse
 * @summary This method triggers datacapture events on a mutation's response
 * @param { Object } data muation response
 */
export const triggerDatacaptureEventOnMutationResponse = ( dataCaptureEventList ) =>{
  if( dataCaptureEventList ){
    dataCaptureEventList.map( dataCaptureEvent => {
      datacapture.processEvents( { dataCapture : dataCaptureEvent }, dataCaptureEvent.clientEvent?.toLowerCase() )
    } )
  }
}

/**
 * @method handleATGResponseStatus
 * @summary this method takes the response status and checks if it falls
 * under specific states it dispatches the customEvent to refresh the session
 * @param  {String} responseStatus
 */
const handleATGResponseStatus = ( responseStatus ) =>{
  if( responseStatus === 'SESSION_CONFLICT' || responseStatus === 'SESSION_INVALIDATE' || responseStatus === 'SESSION_UNAUTHORIZED' || responseStatus === 'UPDATE_SESSION' ){
    dispatchCartUpdate();
  }
}

/**
 * @method refreshATGCart
 * @summary this method takes the response and dispatches event to update ATG cart.
 * @param  {Object} response
 */
export const refreshATGCart = ( response ) => {
  if( response.data ){
    dispatchCartUpdate();
  }
}

/**
 * @method dispatchCartUpdate
 * @summary this method dispatches custom event UpdateReactCartEvent.
 */
const dispatchCartUpdate = () => {
  document.dispatchEvent( new CustomEvent( 'UpdateReactCartEvent' ) );
}
